exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".item[data-v-34228e45]{color:#ffff!important;font-weight:700!important}", "", {"version":3,"sources":["/app/src/components/layout/AppLayout.vue"],"names":[],"mappings":"AACA,uBACE,sBAAwB,AACxB,yBAA6B,CAC9B","file":"AppLayout.vue","sourcesContent":["\n.item[data-v-34228e45] {\n  color: #ffff !important;\n  font-weight: bold !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34228e45","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/AppLayout.vue
// module id = 458
// module chunks = 14